module.exports = __webpack_public_path__ + "static/ontario-c4b498d632b84a3ae5fb9f3c51dcdaa6.png";